var map = {
	"./VnUser-1.png": 380,
	"./VnUser-2.png": 61329,
	"./VnUser-3.png": 92639,
	"./VnUser-4.png": 80725,
	"./VnUser-5.png": 91411,
	"./VnUser-6.png": 22645,
	"./VnUser-7.png": 70491,
	"./VnUser-8.png": 61046,
	"./VnUser-9.png": 921,
	"Common/Components/Carousel/Assets/Imgs/VnUser-1.png": 380,
	"Common/Components/Carousel/Assets/Imgs/VnUser-2.png": 61329,
	"Common/Components/Carousel/Assets/Imgs/VnUser-3.png": 92639,
	"Common/Components/Carousel/Assets/Imgs/VnUser-4.png": 80725,
	"Common/Components/Carousel/Assets/Imgs/VnUser-5.png": 91411,
	"Common/Components/Carousel/Assets/Imgs/VnUser-6.png": 22645,
	"Common/Components/Carousel/Assets/Imgs/VnUser-7.png": 70491,
	"Common/Components/Carousel/Assets/Imgs/VnUser-8.png": 61046,
	"Common/Components/Carousel/Assets/Imgs/VnUser-9.png": 921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57249;